export const iconFontAwesomePhotosImagesDroplet = (
	<i className="fa-solid fa-droplet"></i>
);
